import apiMenu from '@/api/menu'
import * as types from './mutation_types'
import * as clientTypes from '@/store/core/client/mutation_types'

export const getCustomizationInfoDays = async (
  { getters, commit, rootGetters },
  options = {},
) => {
  if (getters.isLoading || getters.deliveryDays.length) {
    return null
  }

  commit(types.RESET_STATE)
  commit(types.IS_LOADING, true)

  let ret = null
  const ops = {
    cityId: options.cityId || rootGetters['city/getActive'].id,
    daysFilterTemplateId: options.daysFilterTemplateId,
  }

  try {
    const response = await apiMenu.getCustomizationInfoDays(ops)
    const { data: { deliveryDays = [] } = {} } = response

    commit(types.SET_DELIVERY_DAYS_LIST, deliveryDays)
    ret = deliveryDays
  } catch (error) {
    ret = error
  } finally {
    commit(types.IS_LOADING, false)
  }

  return ret
}

export const getFilters = ({ commit, getters, rootGetters }, payload = {}) =>
  new Promise((resolve, reject) => {
    const proposeFiltersChange = rootGetters['client/profile']?.proposeFiltersChange
    if (proposeFiltersChange) {
      payload.getProposedVersion = 1
    }
    apiMenu
      .getFilters(payload)
      .then(response => {
        commit(types.SET_FILTERS, response.data.filters)
        commit(types.SET_MAX_ACTIVE_FILTERS_COUNT, response.data.maxActiveFiltersCount)
        if (response.data.promo) {
          commit(types.SET_PROMO_FILTERS, response.data.promo.options)
        }
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })

export const setFilters = ({ commit, state }, payload) =>
  new Promise((resolve, reject) => {
    const filtersPayload = { lastFilterIds: payload }
    const setProposedFiltersVersion = state.setProposedFiltersVersion
    if (setProposedFiltersVersion) {
      filtersPayload.setProposedFiltersVersion = setProposedFiltersVersion
    }

    apiMenu
      .setFilters(filtersPayload)
      .then(response => {
        commit(
          `client/${clientTypes.SET_CLIENT_LAST_FILTER_IDS}`,
          response.data.lastFilterIds,
          { root: true },
        )
        resolve(response.body)
      })
      .catch(error => reject(error))
  })

export const getPackProperties = ({ commit }, payload) =>
  new Promise((resolve, reject) => {
    apiMenu
      .getPackProperties()
      .then(response => {
        commit(types.SET_PACK_PROPERTIES, response.data.packsProperties)
        resolve(response.data)
      })
      .catch(error => reject(error))
  })

export const setUnauthorizedFilters = ({ commit }, filters) => {
  commit(types.SET_UNAUTHORIZED_FILTERS, filters)
}

export const setAppliedUnauthorizedFilters = ({ commit, getters }, filters) => {
  commit(types.SET_APPLIED_UNAUTHORIZED_FILTERS, filters)
  window.localStorage.setItem('appliedUnauthorizedFilters', JSON.stringify(filters))
  const newUnauthorizedFilters = []
  for (const filter of filters) {
    if (
      getters.promoFilters.find(f => {
        return f.name === filter.name
      })
    ) {
      newUnauthorizedFilters.push(filter)
    }
  }
  commit(types.SET_UNAUTHORIZED_FILTERS, newUnauthorizedFilters)
}

export const checkAppliedUnauthorizedFilters = ({ commit, getters }) => {
  const appliedUnauthorizedFiltersToSet = window.localStorage.getItem('appliedUnauthorizedFilters') ? JSON.parse(window.localStorage.getItem('appliedUnauthorizedFilters')) : undefined
  if (!getters.appliedUnauthorizedFilters.length && appliedUnauthorizedFiltersToSet) {
    commit(types.SET_APPLIED_UNAUTHORIZED_FILTERS, appliedUnauthorizedFiltersToSet)
  }

  let unauthorizedFilterIds = window.localStorage.getItem('unauthorizedFilterIds')
  unauthorizedFilterIds = unauthorizedFilterIds ? JSON.parse(unauthorizedFilterIds) : []
  if (unauthorizedFilterIds.length) {
    commit(types.SET_UNAUTHORIZED_LAST_FILTER_IDS, unauthorizedFilterIds)
  }
}

export const getPossibleDeliveryDates = async ({ commit }, payload) => {
  if (!payload.menuType) {
    return
  }
  try {
    const response = await apiMenu.getPossibleDeliveryDates(payload)
    return response?.data
  } catch (e) {
    console.log('getPossibleDeliveryDates error', e)
  }
}

export const setProposedFiltersVersion = ({ commit }, value) => {
  commit(types.SET_PROPOSED_FILTERS_VERSION, value)
}

export const setUpdateFiltersModalVisible = ({ commit }, value) => {
  commit(types.SET_UPDATE_FILTERS_MODAL_VISIBLE, value)
}
